module.exports = __webpack_public_path__ + "img/normal_add.1a8631d3.svg";